import React from 'react'
import { ReactComponent as WandIcon } from '../images/icons/wand.svg'

interface InfoMessageProps {
  content: JSX.Element
}

const InfoMessage: React.FC<InfoMessageProps> = ({ content }) => {
  return (
    <div
      className={
        'flex flex-row items-center bg-cyan-100 self-center py-3 w-full rounded-lg text-sm px-3 border-2 border-primary-persian-blue/10'
      }>
      <div className={'pr-3'}>
        <WandIcon />
      </div>
      {content}
    </div>
  )
}

export default InfoMessage
